import { createSelector } from 'reselect';
import { get } from 'lodash';
import { IState } from './reducer';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE, {}) as IState;

export default selector;

export const expandEventsSelector = createSelector(selector, state =>
  get(state, 'expandEvents', Array.from(new Set<string>())),
);

export const highlightsSelector = createSelector(selector, state =>
  get(state, 'highlights', {}),
);
